import { stumble } from '@ipfabric/frontend-shared-assets/utils/stumble/stumble';
import { type Security, point } from '@ipfabric/utils';
import type { SecuritySchemaCommandFactory } from 'components/SecuritySchema/model/SecuritySchemaModel';
import { isRuleChainScope } from 'components/SecuritySchema/model/SecuritySchemaScope';
import { getRuleChainInitialPage } from 'components/SecuritySchema/model/helpers/getRuleChainInitialPage';

interface NavigateToRuleChainCommand {
  chainName: string;
  securityType: Security.SecurityType;
  /** to save scroll position to breadcrumbs */
  treeScrollContainer?: HTMLElement | null;
}

export const navigateToRuleChain: SecuritySchemaCommandFactory<
  NavigateToRuleChainCommand
> = (cmdContext) => (command) => {
  const scrollPosition = command.treeScrollContainer
    ? {
        x: command.treeScrollContainer.scrollLeft,
        y: command.treeScrollContainer.scrollTop,
      }
    : undefined;
  cmdContext.updateState((draft) => {
    if (!isRuleChainScope(draft.scope)) {
      stumble('Cannot open rule chain when no current scope is active');
      return;
    }
    draft.breadcrumbs.push({
      page: draft.page,
      ruleChainName: draft.scope.name,
      securityType: draft.scope.securityType,
      scrollPosition,
    });
    draft.scope.name = command.chainName;
    draft.scope.securityType = command.securityType;
    draft.scope.scrollPosition = point.zero;
    draft.page = getRuleChainInitialPage(draft);
  });
};
